import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useEffect, useState } from 'react'

// local imports
import successImage from 'assets/images/success-image.svg'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import DateUtil from 'utils/DateUtil'
import NotificationDialog from 'components/ui/NotificationDialog'
import ReservationModalWrapper from 'components/home/on-campus-services/meeting-room/reservation-scheduler/ReservationModal'
import useGetMeetingRoomList from 'components/home/on-campus-services/meeting-room/hooks/use-get-meeting-room-list'
import LoadingWrapper from './LoadingWrapper'

/* filtered date - default */
const today = DateUtil.getStartOfDay(new Date())
interface CompProps {
  id: number
  locationId: number
  setReservationType: (type: TCampusServiceType | 0, item: IFavoriteCampusServices | undefined) => () => void
}

export default function MeetingRes({ locationId, id, setReservationType }: CompProps) {
  const { t } = useTranslation()
  const history = useHistory()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const openModal = () => setModal(true)
  const closeModal = (resetRes = false) => {
    setModal(false)
    if (resetRes) setReservationType(0, undefined)()
  }
  const closeNotification = () => {
    setNotification(false)
    setReservationType(0, undefined)()
  }

  /* Get Meeting Room List - Locations | Custom Hooks */
  const { getMeetingRoomList, meetingRooms, loading } = useGetMeetingRoomList()
  const selectedRoom = meetingRooms.find((r) => r.id === id)
  useEffect(() => {
    getMeetingRoomList({ locationIds: [locationId], reservationDate: today })
    openModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, locationId])

  if (loading) return <LoadingWrapper />

  return (
    <>
      {/* Meeting Room Reservation Scheduler Modal */}
      {!!selectedRoom ? (
        <ReservationModalWrapper
          open={modal}
          openModal={openModal}
          closeModal={closeModal}
          showNotification={() => setNotification(true)}
          selectedRoom={selectedRoom}
          filterDate={today}
        />
      ) : null}

      <NotificationDialog
        display={notification}
        imgSrc={successImage}
        goHomeButton={true}
        title={t('meeting-res-modal.notification-title')}
        content={t('meeting-res-modal.notification-text')}
        firstButtonLabel={t('buttons.go-to-calendar')}
        onHide={closeNotification}
        onSubmit={() => history.push('/calendar')}
        selectedType={null}
        setSelectedType={undefined}
        types={[]}
      />
    </>
  )
}
